// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"e4a72fdd","72":"682a3856","73":"5627a8fc","329":"2e50cbb5","432":"aac8287f","448":"300495f6","488":"3a4806b7","794":"9c5da296","827":"c743a084","945":"db4b70ab"}[chunkId] + ".chunk.js";
};